const state = {
    siteSettings: null,
    gamesData: null,
    bonusData: null,
    domainName: (window.location.hostname.split('.').slice(-2)[0] ? window.location.hostname.split('.').slice(-2)[0].toUpperCase() : ''),
    clickBetValue: null,
    isClickBetOn: false,
    favouriteGames:null,
    globalLoader:false,
    // depositAmount: 0,
    notification:0,
    languagesData:null,
    balExpDisplay:[
        'balance',
        'exposure'
    ],
    languageSelected:null,
    menuShow:true,
    sports_list:null,
    siteVersion:null,
    underMaintenance:null,
    successMsg: null,
    errorMsg: null,
    walletDetails:null,
    logInData: {
        logInWithMobile: false,
        userIds: []
    },
    userTransactionStakes: null,
    androidclose : false,
};
const getters = {
    siteSettings: state => state?.siteSettings,
    gamesData: state => state?.gamesData,
    bonusData: state => state?.bonusData,
    languagesData: state => state?.languagesData,
    languageSelected: state => state?.languageSelected,
    clickBetActive: state => state?.clickBetValue?.find(item => item.isSelected) ?? false,
    domainName: state => state?.domainName,
    clickBetValue: state => state?.clickBetValue,
    isClickBetOn: state => state?.isClickBetOn,
    favouriteGames:state => state?.favouriteGames,
    globalLoader:state => state?.globalLoader,
    // depositAmount:state => state?.depositAmount,
    getNotification: state => state?.notification,
    getBalExpDisplay: state => state?.balExpDisplay,
    getRecommendedMatch: state => state?.recommendedMatch,
    menuShow: state => state?.menuShow,
    sports_list: state => state?.sports_list,
    siteVersion: state => state?.siteVersion,
    underMaintenance: state => state?.underMaintenance,
    successMsg: state => state?.successMsg,
    errorMsg: state => state?.errorMsg,
    getSportImage: state => (sportId) => {
        const imageMap = {
            4: require("@/assets/images/sports-cricket.png"),
            1: require("@/assets/images/sports-soccer.png"),
            2: require("@/assets/images/sports-tennis.png"),
            1477: require("@/assets/images/sports-rugby-league.png"),
            6: require("@/assets/images/sports-boxing.png"),
            5: require("@/assets/images/sports-rugby-union.png"),
            3: require("@/assets/images/sports-golf.png"),
            27454571: require("@/assets/images/sports-esports.png"),
            2152880: require("@/assets/images/sports-gaelic-football.png"),
            998917: require("@/assets/images/sports-volleyball.png"),
            7524: require("@/assets/images/sports-ice-hockey.png"),
            7522: require("@/assets/images/sports-basketball.png"),
            7511: require("@/assets/images/sports-baseball.png"),
            6423: require("@/assets/images/sports-american-football.png"),
            6422: require("@/assets/images/sports-snooker.png"),
            11: require("@/assets/images/sports-cycling.png"),
            8: require("@/assets/images/sports-motor-sport.png"),
            2378961: require("@/assets/images/sports-politics.png"),
            468328: require("@/assets/images/sports-handball.png"),
            61420: require("@/assets/images/sports-australian-rules.png"),
            3503: require("@/assets/images/sports-darts.png"),
            10: require("@/assets/images/sports-special-bets.png"),
            26420387: require("@/assets/images/sports-mixed-martial-arts.png"),
            4339: require("@/assets/images/sports-greyhound-racing.png"),
            7: require("@/assets/images/sports-horse-racing.png"),
        };
        return imageMap[sportId] || require("@/assets/images/sports-no.png");
    },
    walletDetails: state => state?.walletDetails,
    logInData: state => state?.logInData,
    userTransactionStakes: state => state?.userTransactionStakes,
    androidclose: state => state?.androidclose,
};
const actions = {
    setSettings({ commit }, siteSettings) {
        commit('setSettings', siteSettings);
    },
    setLanguagesData({ commit }, languagesData) {
        commit('setLanguagesData', languagesData);
    },
    setLanguageSelected({ commit }, languageSelected) {
        commit('setLanguageSelected', languageSelected);
    },
    setGamesData({ commit }, gamesData) {
        commit('setGamesData', gamesData);
    },
    setBonusData({ commit }, bonusData) {
        commit('setBonusData', bonusData);
    },
    setClickBetValue({ commit }, clickBetValue) {
        commit('setClickBetValue', clickBetValue);
    },
    setIsClickBetOn({ commit }, isClickBetOn) {
        commit('setIsClickBetOn', isClickBetOn);
    },
    setFavouriteGames({ commit }, favouriteGames) {
        commit('setFavouriteGames', favouriteGames);
    },
    setGlobalLoader({ commit }, globalLoader) {
        commit('setGlobalLoader', globalLoader);
    },
    // setDepositAmount({ commit }, depositAmount) {
    //     commit('setDepositAmount', depositAmount);
    // },    
    setNotification({ commit }, notification) {
        commit('setNotification', notification);
    },
    setBalExpDisplay({ commit }, balExpDisplay) {
        commit('setBalExpDisplay', balExpDisplay);
    },
    setRecommendedMatch({ commit }, RecommendedMatch) {
        commit('setRecommendedMatch', RecommendedMatch);
    },
    setMenuShow({ commit }, menuShow) {
        commit('setMenuShow', menuShow);
    },
    setSportsList({ commit }, sports_list) {
        commit('setSportsList', sports_list);
    },
    setUnderMaintenance({ commit }, underMaintenance) {
        commit('setUnderMaintenance', underMaintenance);
    },
    setSiteVersion({ commit }, siteVersion) {
        commit('setSiteVersion', siteVersion);
    },
    showSuccessModal({ commit }, message) {
        commit('showSuccessModal', message);
        setTimeout(() => {
            commit('showSuccessModal', null);
        }, 3000);
    },
    showErrorModal({ commit }, message) {
        commit('showErrorModal', message);
        setTimeout(() => {
            commit('showErrorModal', null);
        }, 3000);
    },
    setWalletDetails({ commit }, walletDetails) {
        commit('setWalletDetails', walletDetails);
    },
    setLogInData({commit}, data) {
        commit('setLogInData', data)
    },
    setUserTransactionStakes({ commit }, userTransactionStakes) {
        commit('setUserTransactionStakes', userTransactionStakes);
    },
    Setandroidclose({ commit }, androidclose) {
        commit('Setandroidclose', androidclose);
    },
};
const mutations = {
    setSettings(state, siteSettings) {
        state.siteSettings = siteSettings
    },
    setLanguagesData(state, languagesData) {
        state.languagesData = languagesData;
    },
    setLanguageSelected(state, languageSelected) {
        state.languageSelected = languageSelected;
    },
    setGamesData(state, gamesData) {
        state.gamesData = gamesData;;
    },
    setBonusData(state, bonusData) {
        state.bonusData = bonusData;;
    },
    setClickBetValue(state, clickBetValue) {
        state.clickBetValue = clickBetValue;
    },
    setIsClickBetOn(state, isClickBetOn) {
        state.isClickBetOn = isClickBetOn;
    },
    setFavouriteGames(state, favouriteGames) {
        state.favouriteGames = favouriteGames;
    },
    setGlobalLoader(state, globalLoader) {
        state.globalLoader = globalLoader;
    },
    // setDepositAmount(state, depositAmount){
    //     state.depositAmount =  depositAmount
    // },    
    setNotification(state) {
        state.notification = state.notification+1;
    },
    setBalExpDisplay(state, balExpDisplay) {
        state.balExpDisplay = balExpDisplay;
    },
    setRecommendedMatch(state, RecommendedMatch) {
        state.recommendedMatch = RecommendedMatch;
    },
    setMenuShow(state, menuShow) {
        state.menuShow = menuShow;
    },
    setSportsList(state, sports_list) {
        state.sports_list = sports_list;
    },
    setSiteVersion(state, siteVersion) {
        state.siteVersion = siteVersion;
    },
    setUnderMaintenance(state, underMaintenance) {
        state.underMaintenance = underMaintenance;
    },
    showSuccessModal(state, message) {
        state.successMsg = message
    },
    showErrorModal(state, message) {
        state.errorMsg = message
    },
    setWalletDetails(state, walletDetails) {
        state.walletDetails = walletDetails;
    },
    setLogInData(state, data) {
        state.logInData = data
    },
    setUserTransactionStakes(state, userTransactionStakes) {
        state.userTransactionStakes = userTransactionStakes;
    },
    Setandroidclose(state, androidclose) {
        state.androidclose = androidclose;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};